export default __webpack_public_path__ + "static/media/IMG-20240708-WA0016.5a9220e0.jpg";